package com.daytimegaming.ourdailyfinances.presentation.theme

import androidx.compose.ui.graphics.Color

// Light Scheme Colors
val primaryLight = Color(0xFF006B5F)
val primaryLightMediumContrast = Color(0xFF004D44)
val primaryLightHighContrast = Color(0xFF002923)
val onPrimaryLight = Color(0xFFFFFFFF)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFF80DEC9)
val primaryContainerLightMediumContrast = Color(0xFF006B5F)
val primaryContainerLightHighContrast = Color(0xFF004D44)
val onPrimaryContainerLight = Color(0xFF00201C)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)

val secondaryLight = Color(0xFF4A635D)
val secondaryLightMediumContrast = Color(0xFF2E4742)
val secondaryLightHighContrast = Color(0xFF0D2622)
val onSecondaryLight = Color(0xFFFFFFFF)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFCCE8E0)
val secondaryContainerLightMediumContrast = Color(0xFF4A635D)
val secondaryContainerLightHighContrast = Color(0xFF2E4742)
val onSecondaryContainerLight = Color(0xFF05201A)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)

val tertiaryLight = Color(0xFF3F6375)
val tertiaryLightMediumContrast = Color(0xFF224758)
val tertiaryLightHighContrast = Color(0xFF002635)
val onTertiaryLight = Color(0xFFFFFFFF)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFC2E8FD)
val tertiaryContainerLightMediumContrast = Color(0xFF3F6375)
val tertiaryContainerLightHighContrast = Color(0xFF224758)
val onTertiaryContainerLight = Color(0xFF001F2A)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)

val errorLight = Color(0xFFBA1A1A)
val errorLightMediumContrast = Color(0xFF8C0009)
val errorLightHighContrast = Color(0xFF4E0002)
val onErrorLight = Color(0xFFFFFFFF)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val errorContainerLightMediumContrast = Color(0xFFDA342E)
val errorContainerLightHighContrast = Color(0xFF8C0009)
val onErrorContainerLight = Color(0xFF410002)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)

val backgroundLight = Color(0xFFF8FAFC)
val backgroundLightMediumContrast = Color(0xFFF8FAFC)
val backgroundLightHighContrast = Color(0xFFF8FAFC)
val onBackgroundLight = Color(0xFF101415)
val onBackgroundLightMediumContrast = Color(0xFF101415)
val onBackgroundLightHighContrast = Color(0xFF101415)

val surfaceLight = Color(0xFFF8FAFC)
val surfaceLightMediumContrast = Color(0xFFF8FAFC)
val surfaceLightHighContrast = Color(0xFFF8FAFC)
val onSurfaceLight = Color(0xFF101415)
val onSurfaceLightMediumContrast = Color(0xFF101415)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLight = Color(0xFFDAE5E1)
val surfaceVariantLightMediumContrast = Color(0xFFDAE5E1)
val surfaceVariantLightHighContrast = Color(0xFFDAE5E1)
val onSurfaceVariantLight = Color(0xFF3F4946)
val onSurfaceVariantLightMediumContrast = Color(0xFF3B4542)
val onSurfaceVariantLightHighContrast = Color(0xFF1D2523)

val outlineLight = Color(0xFF6F7976)
val outlineLightMediumContrast = Color(0xFF535D5A)
val outlineLightHighContrast = Color(0xFF353E3C)
val outlineVariantLight = Color(0xFFBEC9C5)
val outlineVariantLightMediumContrast = Color(0xFF707A77)
val outlineVariantLightHighContrast = Color(0xFF535D5A)

val scrimLight = Color(0xFF000000)
val scrimLightMediumContrast = Color(0xFF000000)
val scrimLightHighContrast = Color(0xFF000000)

val inverseSurfaceLight = Color(0xFF2A3230)
val inverseSurfaceLightMediumContrast = Color(0xFF2A3230)
val inverseSurfaceLightHighContrast = Color(0xFF2A3230)
val inverseOnSurfaceLight = Color(0xFFECF2EE)
val inverseOnSurfaceLightMediumContrast = Color(0xFFECF2EE)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLight = Color(0xFF80DEC9)
val inversePrimaryLightMediumContrast = Color(0xFF80DEC9)
val inversePrimaryLightHighContrast = Color(0xFFD4F0FF)

val surfaceDimLight = Color(0xFFD5DBD8)
val surfaceDimLightMediumContrast = Color(0xFFD5DBD8)
val surfaceDimLightHighContrast = Color(0xFFD5DBD8)
val surfaceBrightLight = Color(0xFFF4FAF7)
val surfaceBrightLightMediumContrast = Color(0xFFF4FAF7)
val surfaceBrightLightHighContrast = Color(0xFFF4FAF7)

val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFEEF4F1)
val surfaceContainerLowLightMediumContrast = Color(0xFFEEF4F1)
val surfaceContainerLowLightHighContrast = Color(0xFFEEF4F1)
val surfaceContainerLight = Color(0xFFE8EEEC)
val surfaceContainerLightMediumContrast = Color(0xFFE8EEEC)
val surfaceContainerLightHighContrast = Color(0xFFE8EEEC)
val surfaceContainerHighLight = Color(0xFFE2E9E6)
val surfaceContainerHighLightMediumContrast = Color(0xFFE2E9E6)
val surfaceContainerHighLightHighContrast = Color(0xFFE2E9E6)
val surfaceContainerHighestLight = Color(0xFFDCE3E0)
val surfaceContainerHighestLightMediumContrast = Color(0xFFDCE3E0)
val surfaceContainerHighestLightHighContrast = Color(0xFFDCE3E0)

// Dark Scheme Colors
val primaryDark = Color(0xFF57F1DB)
val primaryDarkMediumContrast = Color(0xFF62FAE3)
val primaryDarkHighContrast = Color(0xFFF7FBFF)
val onPrimaryDark = Color(0xFF003731)
val onPrimaryDarkMediumContrast = Color(0xFF001A16)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDark = Color(0xFF2DD4BF)
val primaryContainerDarkMediumContrast = Color(0xFF3CDDC7)
val primaryContainerDarkHighContrast = Color(0xFF8FD4F3)
val onPrimaryContainerDark = Color(0xFF00574D)
val onPrimaryContainerDarkMediumContrast = Color(0xFF000000)
val onPrimaryContainerDarkHighContrast = Color(0xFF000000)

val secondaryDark = Color(0xFFBEC6E0)
val secondaryDarkMediumContrast = Color(0xFFBEC6E0)
val secondaryDarkHighContrast = Color(0xFFF7FBFF)
val onSecondaryDark = Color(0xFF283044)
val onSecondaryDarkMediumContrast = Color(0xFF131B2E)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDark = Color(0xFF3F465C)
val secondaryContainerDarkMediumContrast = Color(0xFF3F465C)
val secondaryContainerDarkHighContrast = Color(0xFFB8CEDA)
val onSecondaryContainerDark = Color(0xFFADB4CE)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val onSecondaryContainerDarkHighContrast = Color(0xFF000000)

val tertiaryDark = Color(0xFFCADBF5)
val tertiaryDarkMediumContrast = Color(0xFFCADBF5)
val tertiaryDarkHighContrast = Color(0xFFFDF9FF)
val onTertiaryDark = Color(0xFF213145)
val onTertiaryDarkMediumContrast = Color(0xFF0B1C30)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDark = Color(0xFFAFBFD9)
val tertiaryContainerDarkMediumContrast = Color(0xFFAFBFD9)
val tertiaryContainerDarkHighContrast = Color(0xFFCAC7EF)
val onTertiaryContainerDark = Color(0xFF3E4E63)
val onTertiaryContainerDarkMediumContrast = Color(0xFF000000)
val onTertiaryContainerDarkHighContrast = Color(0xFF000000)

val errorDark = Color(0xFFFFB4AB)
val errorDarkMediumContrast = Color(0xFFFFBAB1)
val errorDarkHighContrast = Color(0xFFFFF9F9)
val onErrorDark = Color(0xFF690005)
val onErrorDarkMediumContrast = Color(0xFF370001)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDark = Color(0xFF93000A)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val errorContainerDarkHighContrast = Color(0xFFFFBAB1)
val onErrorContainerDark = Color(0xFFFFDAD6)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val onErrorContainerDarkHighContrast = Color(0xFF000000)

val backgroundDark = Color(0xFF101415)
val backgroundDarkMediumContrast = Color(0xFF101415)
val backgroundDarkHighContrast = Color(0xFF101415)
val onBackgroundDark = Color(0xFFE0E3E5)
val onBackgroundDarkMediumContrast = Color(0xFFE0E3E5)
val onBackgroundDarkHighContrast = Color(0xFFE0E3E5)

val surfaceDark = Color(0xFF101415)
val surfaceDarkMediumContrast = Color(0xFF101415)
val surfaceDarkHighContrast = Color(0xFF101415)
val onSurfaceDark = Color(0xFFE0E3E5)
val onSurfaceDarkMediumContrast = Color(0xFFF7FBFF)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDark = Color(0xFF323537)
val surfaceVariantDarkMediumContrast = Color(0xFF323537)
val surfaceVariantDarkHighContrast = Color(0xFF323537)
val onSurfaceVariantDark = Color(0xFFBACAC5)
val onSurfaceVariantDarkMediumContrast = Color(0xFFC4CCD1)
val onSurfaceVariantDarkHighContrast = Color(0xFFF7FBFF)

val outlineDark = Color(0xFF859490)
val outlineDarkMediumContrast = Color(0xFF9CA4A9)
val outlineDarkHighContrast = Color(0xFFC4CCD1)
val outlineVariantDark = Color(0xFF3C4A46)
val outlineVariantDarkMediumContrast = Color(0xFF7C8489)
val outlineVariantDarkHighContrast = Color(0xFFC4CCD1)

val scrimDark = Color(0xFF000000)
val scrimDarkMediumContrast = Color(0xFF000000)
val scrimDarkHighContrast = Color(0xFF000000)

val inverseSurfaceDark = Color(0xFFE0E3E5)
val inverseSurfaceDarkMediumContrast = Color(0xFFE0E3E5)
val inverseSurfaceDarkHighContrast = Color(0xFFE0E3E5)
val inverseOnSurfaceDark = Color(0xFF2D3133)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF262B2D)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDark = Color(0xFF006B5F)
val inversePrimaryDarkMediumContrast = Color(0xFF004E65)
val inversePrimaryDarkHighContrast = Color(0xFF002E3D)

val surfaceDimDark = Color(0xFF101415)
val surfaceDimDarkMediumContrast = Color(0xFF101415)
val surfaceDimDarkHighContrast = Color(0xFF101415)
val surfaceBrightDark = Color(0xFF363A3B)
val surfaceBrightDarkMediumContrast = Color(0xFF363A3B)
val surfaceBrightDarkHighContrast = Color(0xFF363A3B)

val surfaceContainerLowestDark = Color(0xFF0B0F10)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF0B0F10)
val surfaceContainerLowestDarkHighContrast = Color(0xFF0B0F10)
val surfaceContainerLowDark = Color(0xFF191C1E)
val surfaceContainerLowDarkMediumContrast = Color(0xFF191C1E)
val surfaceContainerLowDarkHighContrast = Color(0xFF191C1E)
val surfaceContainerDark = Color(0xFF1D2022)
val surfaceContainerDarkMediumContrast = Color(0xFF1D2022)
val surfaceContainerDarkHighContrast = Color(0xFF1D2022)
val surfaceContainerHighDark = Color(0xFF272A2C)
val surfaceContainerHighDarkMediumContrast = Color(0xFF272A2C)
val surfaceContainerHighDarkHighContrast = Color(0xFF272A2C)
val surfaceContainerHighestDark = Color(0xFF323537)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF323537)
val surfaceContainerHighestDarkHighContrast = Color(0xFF323537)
